import home from '@assets/home.png';
import { LoginPanel } from '@components';
import classes from './index.module.css';

const TITLE_NORMAL = 'Resolve issues with';
const TITLE_SEEL = 'Seel';

export const Login = () => (
  <div className={classes.content}>
    <section className={classes.left_part}>
      <section className={classes.title}>
        {TITLE_NORMAL}
        <span className={classes.title_seel}>
          {TITLE_SEEL}
          <span className={classes.title_block}></span>
        </span>
      </section>
      <section>
        <img src={home} className={classes.home_icon} alt="" />
      </section>
    </section>
    <LoginPanel />
  </div>
);
